module.exports = __webpack_public_path__ + "static/img/pl.7a9dc853.png";